// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Mywallet.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import socket from "../Components/socket";
// import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
// import { BsWallet2 } from "react-icons/bs";
// import io from "../Components/socket";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { VscReferences } from "react-icons/vsc";

// const Mywallet = ({ user }) => {
//   // const [user, setUser] = useState();

//   const access_token = localStorage.getItem("token");
//   //   const walletUpdate =()=>{
//   //  io.emit("getprofile", access_token);
//   //   io.on("setProfile", (data) => {
//   //     setUser(data);
//   //   });
//   //   }

//   //   useEffect(()=>{
//   //     walletUpdate()
//   //   },[]);

//   // language
//   const translations = {
//     hi: {
//       wallet: "वॉलेट",
//       history: "इतिहास देखे | ",
//       amount: "पैसे जोड़ें | ",
//       withdraw: "पैसे निकाले  | ",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       wallet: "My Wallet",
//       history: "Order History",
//       amount: "Add Cash",
//       withdraw: "Withdraw",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme = localStorage.getItem("theme");

//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e3fd" : "#000",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <>
//       <div
//         className="leftContainer mb_space"
//         style={{ ...styles, height: "100vh" }}
//       >
//         <div className="balance-section pt-2 mt-5 Orher_page_main_section">
//           <div className="mt-2">
//             <h3 className="mb-3">Balance</h3>

//             {/* Deposit Cash Card */}
//             <div className="unique-card">
//               <div className="unique-card-left">
//                 <img src="/images/deposit.png" className="card-main-img" />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Deposit Cash</h2>

//                 <div className="uc-amount">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.Wallet_balance - user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/addcase">
//                   <button className="uc-btn">
//                     <AiOutlinePlus className="icons" />{" "}
//                     {translations[language].amount}
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Winning Cash Card */}
//             <div className="unique-card win">
//               <div className="unique-card-left">
//                 <img
//                   src="/images/win-cash.png"
//                   className="card-main-img"
//                   style={{ transform: "scale(1.5)" }}
//                 />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Winning Cash</h2>

//                 <div className="uc-amount text-danger">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/Withdrawopt">
//                   <button className="uc-btn withdraw">
//                     <BsWallet2 className="icons" />{" "}
//                     {translations[language].withdraw}
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rightContainer">
//           <div>
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Mywallet;

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import {
  MdDownload,
  MdUpload,
  MdAccountBalanceWallet,
  MdAdd,
  MdArrowForward,
  MdVerified,
  MdSecurity,
  MdPayments
} from "react-icons/md";

const Mywallet = ({ user }) => {

  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },

    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user
    ? (user.Wallet_balance - user.withdrawAmount).toFixed(2)
    : "0.00";

  const winningAmount = user
    ? user.withdrawAmount.toFixed(2)
    : "0.00";

  const totalBalance =
    Number(depositAmount) + Number(winningAmount);


  return (
    <div className="prince_wallet_page">

      <div className="prince_wallet_main">


        {/* =================================================
            WALLET HERO
        ================================================= */}

        <section className="prince_wallet_hero">

          <div className="prince_wallet_glow prince_wallet_glow_one"></div>
          <div className="prince_wallet_glow prince_wallet_glow_two"></div>


          <div className="prince_wallet_top">

            <div className="prince_wallet_title">

              <div className="prince_wallet_icon_3d">

                <div>
                  <MdAccountBalanceWallet />
                </div>

                <span></span>

              </div>


              <div>

                <small>
                  PRINCE LUDO WALLET
                </small>

                <h2>
                  My Wallet
                </h2>

              </div>

            </div>


            <div className="prince_wallet_secure_badge">

              <MdVerified />

              <span>
                VERIFIED
              </span>

            </div>

          </div>


          {/* BALANCE */}

          <div className="prince_wallet_balance">

            <span>
              Total Wallet Balance
            </span>

            <h1>
              ₹ {totalBalance.toFixed(2)}
            </h1>

            <div className="prince_wallet_balance_status">

              <span></span>

              {t.availablePlay}

            </div>

          </div>


          {/* HERO FOOTER */}

          <div className="prince_wallet_hero_footer">

            <span></span>

            <div>
              <MdSecurity />
              SAFE & SECURE WALLET
            </div>

            <span></span>

          </div>

        </section>


        {/* =================================================
            WALLET BREAKDOWN
        ================================================= */}

        {/* <div className="prince_wallet_section_heading">

          <div>

            <small>
              WALLET OVERVIEW
            </small>

            <h2>
              Balance Breakdown
            </h2>

          </div>

          <span>✦</span>

        </div> */}


        <section className="prince_wallet_stats">


          {/* DEPOSITED */}

          <div className="prince_wallet_stat prince_deposit_stat">

            <div className="prince_wallet_stat_top">

              <div className="prince_wallet_stat_icon">
                <MdDownload />
              </div>

              <span>
                DEPOSITED
              </span>

            </div>


            <div className="prince_wallet_stat_content">

              <small>
                {t.deposit}
              </small>

              <strong>
                ₹ {depositAmount}
              </strong>

              <span>
                AVAILABLE BALANCE
              </span>

            </div>

          </div>


          {/* WINNINGS */}

          <div className="prince_wallet_stat prince_winning_stat">

            <div className="prince_wallet_stat_top">

              <div className="prince_wallet_stat_icon">
                <MdUpload />
              </div>

              <span>
                WINNINGS
              </span>

            </div>


            <div className="prince_wallet_stat_content">

              <small>
                {t.winnings}
              </small>

              <strong>
                ₹ {winningAmount}
              </strong>

              <span>
                WITHDRAWABLE BALANCE
              </span>

            </div>

          </div>

        </section>


        {/* =================================================
            ACTIONS
        ================================================= */}

        <div className="prince_wallet_action_heading">

          <small>
            WALLET ACTIONS
          </small>

          <h2>
            Manage Your Money
          </h2>

        </div>


        <section className="prince_wallet_actions">


          {/* ADD CHIPS */}

          <Link
            to="/addcase"
            className="prince_wallet_action prince_add_action"
          >

            <div className="prince_action_decor">
              +
            </div>


            <div className="prince_action_top">

              <div className="prince_action_icon">

                <MdAdd />

              </div>

              <div className="prince_action_arrow">
                <MdArrowForward />
              </div>

            </div>


            <div className="prince_action_content">

              <small>
                ADD MONEY
              </small>

              <h3>
                {t.deposit}
              </h3>

              <p>
                Add money instantly to your wallet.
              </p>

            </div>


            <div className="prince_action_bottom">

              <MdPayments />

              <span>
                Fast & Easy Deposit
              </span>

            </div>

          </Link>


          {/* WITHDRAW */}

          <Link
            to="/Withdrawopt"
            className="prince_wallet_action prince_withdraw_action"
          >

            <div className="prince_action_decor">
              ₹
            </div>


            <div className="prince_action_top">

              <div className="prince_action_icon">

                <MdUpload />

              </div>

              <div className="prince_action_arrow">
                <MdArrowForward />
              </div>

            </div>


            <div className="prince_action_content">

              <small>
                CASH OUT
              </small>

              <h3>
                {t.withdraw}
              </h3>

              <p>
                Transfer winnings directly to your bank.
              </p>

            </div>


            <div className="prince_action_bottom">

              <MdAccountBalanceWallet />

              <span>
                Quick & Secure Withdrawal
              </span>

            </div>

          </Link>

        </section>


        {/* =================================================
            SECURITY CARD
        ================================================= */}

        <section className="prince_wallet_security">

          <div className="prince_wallet_security_icon">

            <MdSecurity />

          </div>


          <div className="prince_wallet_security_text">

            <strong>
              SECURE & VERIFIED TRANSACTIONS
            </strong>

            <span>
              {t.secure}
            </span>

          </div>


          <MdVerified className="prince_wallet_security_check" />

        </section>


        {/* =================================================
            FOOTER
        ================================================= */}

        <div className="prince_wallet_footer">

          <span></span>

          <div>
            ✦ PRINCE LUDO ✦
          </div>

          <span></span>

        </div>


      </div>

    </div>
  );
};

export default Mywallet;